import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { compose } from 'recompose';

import { querySelector } from '../../../utils';
import queryMetaHandler from '../../../utils/queryMetaHandler';

const GET_CURRENT_PAY_PERIOD = gql`
  query GetCurrentPayPeriod {
    current_pay_period {
      id
      start_date {
        display
      }
      end_date {
        display
      }
    }
  }
`;

const marshallPayPeriodData = ({ data, ownProps }) => {
  const defaultPayPeriod = {
    start_date: '',
    end_date: '',
  };
  const currentPayPeriod = querySelector(data, '$.current_pay_period', [defaultPayPeriod])[0];
  return {
    data,
    ...ownProps,
    currentPayPeriod,
  };
};

const queryCurrentPayPeriod = graphql(GET_CURRENT_PAY_PERIOD, { props: marshallPayPeriodData });

export const queryCurrentPayPeriodGQL = compose(
  queryCurrentPayPeriod,
  queryMetaHandler,
);
